import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

interface FormFieldLabelProps {
  children: ReactNode;
  htmlFor?: string;
  id?: string;
  required?: boolean;
  className?: string;
}

export function Label({ children, htmlFor, id, required, className }: FormFieldLabelProps) {
  return (
    <label htmlFor={htmlFor} id={id} className={filterClasses("body-sm-alt text-grey-600", className)}>
      {children}
      {required && <span className="ml-1 text-red-500">*</span>}
    </label>
  );
}
